import Crud from '@/stores/crudBase';
import api from '@/apis/fa/qltsVoucherAPI.js';
var crud = new Crud('approveVoucherQltsVoucher', api);

const state = {
  ...crud.state,
  _config: {
    table: 'qlts_voucher',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Sinh chứng từ khi chọn tài sản từ QLTS
   * TVDAT 07/09/2022
   */
  async generateVoucherQlts(context, payload) {
    let res = await api.generateVoucherQlts(payload);
    if (res) {
      return res;
    }
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
